export default "__VITE_ASSET__DyvRBi7p__"